"use strict";
'use es6'; // Ranges are from https://git.hubteam.com/HubSpot/signup_ui/blob/master/signup_ui/static/js/routeHandlers/UserRegistration/academy/academyAnswerMapping.js

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREFER_NOT_TO_SAY = exports.RANGE_10001_ = exports.RANGE_1001_10000 = exports.RANGE_201_1000 = exports.RANGE_51_200 = exports.RANGE_26_50 = exports.RANGE_11_25 = exports.RANGE_6_10 = exports.RANGE_2_5 = exports.RANGE_1 = void 0;
var RANGE_1 = 'RANGE_1';
exports.RANGE_1 = RANGE_1;
var RANGE_2_5 = 'RANGE_2_5';
exports.RANGE_2_5 = RANGE_2_5;
var RANGE_6_10 = 'RANGE_6_10';
exports.RANGE_6_10 = RANGE_6_10;
var RANGE_11_25 = 'RANGE_11_25';
exports.RANGE_11_25 = RANGE_11_25;
var RANGE_26_50 = 'RANGE_26_50';
exports.RANGE_26_50 = RANGE_26_50;
var RANGE_51_200 = 'RANGE_51_200';
exports.RANGE_51_200 = RANGE_51_200;
var RANGE_201_1000 = 'RANGE_201_1000';
exports.RANGE_201_1000 = RANGE_201_1000;
var RANGE_1001_10000 = 'RANGE_1001_10000';
exports.RANGE_1001_10000 = RANGE_1001_10000;
var RANGE_10001_ = 'RANGE_10001_';
exports.RANGE_10001_ = RANGE_10001_;
var PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY';
exports.PREFER_NOT_TO_SAY = PREFER_NOT_TO_SAY;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/CompanySize.js
// module id = 227
// module chunks = 209 210 211 212